module.exports = __webpack_public_path__ + "static/media/Griffin_Q.024095f0.jpg";